<template>
  <pt-goods-of-integral class="pt-goods-of-integral__page"></pt-goods-of-integral>
</template>

<script>
import PtGoodsOfIntegral from 'cps/integral-mall-manage/pt-goods-of-integral/withData'
export default {
  name: 'pt-goods-of-integral__view',
  components: {
    'pt-goods-of-integral': PtGoodsOfIntegral
  }
}
</script>
